import { isWebview } from './is-webview';
export const sendWebviewEvent = (data) => {
    if (isWebview) {
        try {
            if (typeof window !== 'undefined' && typeof window.ReactNativeWebView !== 'undefined') {
                const dataStringified = JSON.stringify({ ...data });
                window.ReactNativeWebView.postMessage(dataStringified);
            }
        } catch (err) {
        }
    }
};